<template>
  <div class="results-gallery">
    <ResultsViews currentView="gallery" @gallery="goToColorWall" @list="goToColorList"/>

    <div class="results-gallery__header">
      <div v-if="heroColor" class="header__headline">{{resultTitle}}</div>
      <h1 v-if="heroColor" :inner-html.prop="heroColor.colourName | colourTitleHtml"></h1>
      <h2 v-if="heroColor">{{heroColor.id}}</h2>
    </div>

    <!-- Zoom/pan main grid -->
    <!-- component panzoom doc: https://github.com/anvaka/panzoom & https://www.npmjs.com/package/vue-panzoom -->
    <div class="zoom-container">
      <panZoom :options="{minZoom: 1, maxZoom: 6, bounds: true, boundsPadding: 1, zoomSpeed: 0.04, zoomDoubleClickSpeed: 1}"
               @zoom = onZoom>
        <div>
          <!-- Pinch/zoom image overlay -->
          <div class="pinch-zoom-overlay" v-bind:class="{'fadeOut': !overlayVisible}"></div>

          <!-- Whites section left -->
          <div class="grid-left small" v-if="wallType === 'small' && (slide === 'left' || !mobileView)">
            <h3 style="margin-top: 0">Whites</h3>
            <ColorGrid :wallColors="whitesWall" :heroColor="heroColor" :colors="colors" grid="whites"/>

            <h3>Neutrals</h3>
            <ColorGrid :wallColors="neutralsWall" :heroColor="heroColor" :colors="colors" grid="neutrals"/>

            <h3>Greys</h3>
            <ColorGrid :wallColors="greysWall" :heroColor="heroColor" :colors="colors" grid="greys"/>

            <h3>Colorbond®</h3>
            <ColorGrid :wallColors="colorbondWall" :heroColor="heroColor" :colors="colors" grid="colorbond"/>
          </div>
          
          <!-- main grid -->
          <ColorGrid :wallColors="mainWall" :heroColor="heroColor" :colors="colors" :grid="wallType" v-bind:class="slide" />

          <!-- Colorbond section right -->
          <div class="grid-right" v-if="wallType === 'large' && (slide === 'right' || !mobileView)">
            <h3 style="margin-top: 0">Whites</h3>
            <ColorGrid :wallColors="whitesWall" :heroColor="heroColor" :colors="colors" grid="whites"/>

            <h3>Neutrals</h3>
            <ColorGrid :wallColors="neutralsWall" :heroColor="heroColor" :colors="colors" grid="neutrals"/>

            <h3>Greys</h3>
            <ColorGrid :wallColors="greysWall" :heroColor="heroColor" :colors="colors" grid="greys"/>

            <h3>Colorbond®</h3>
            <ColorGrid :wallColors="colorbondWall" :heroColor="heroColor" :colors="colors" grid="colorbond"/>
          </div>
        </div>
      </panZoom>
    </div>
    <SlideWhitesColorbond 
      :slide="slide"
      :wallType="wallType"
      :allowSlide="allowSlide"
      @slideGrid="slideGrid"
      v-if="mobileView" />

  </div>
</template>

<script>
import { keyBy } from 'lodash'
import ResultsViews from './elements/results/ResultsViews'
import ColorGrid from './elements/results/ColorGrid'
import SlideWhitesColorbond from './elements/results/SlideWhitesColorbond'
import {randomTitlesResults} from '../assets/data/data.js'
import allColours from '../assets/data/allColours.json'

const allColourMap = keyBy(allColours, 'colourName');

export default {
  name: 'ResultsGallery',
  components: { ResultsViews, ColorGrid, SlideWhitesColorbond },
  props: {
    primaryColor: Object,
    colors: Array
  },
  data() {
    return {
      resultTitle: randomTitlesResults[Math.floor(Math.random() * Math.floor(randomTitlesResults.length))],
      allowSlide: true,
      overlayVisible: true,
      slide: 'center',
      mobileView: true,
    }
  },
  computed: {
    selectedColor() {
      return this.$store.state.selectedColor
    },
    heroColor() {
      const heroColor = this.primaryColor || this.selectedColor;
      return allColourMap[heroColor.colourName]
    },
    wallType () {
      return this.$route.query.wall || 'large'
    },
    mainWall() {
      switch(this.wallType) {
        case 'small':
          return require('../assets/data/smallWall.json')
        case 'large':
          return require('../assets/data/largeWall.json')
        default:
          return {};
      }
    },
    sideWalls() {
      switch(this.wallType) {
        case 'small':
          return require('../assets/data/smallSideWalls.json')
        case 'large':
          
          return require('../assets/data/largeSideWalls.json')
        default:
          return {};
      }
    },
    whitesWall() {
      return this.sideWalls.whites
    },
    neutralsWall() {
      return this.sideWalls.neutrals
    },
    greysWall() {
      return this.sideWalls.greys
    },
    colorbondWall() {
      return this.sideWalls.colorbond
    }
  },
  mounted() {
    this.$store.commit('updateBg', [255,255,255]);
    this.overlayVisible = false;
  },
  created() {
    let colourWall;
    if (this.heroColor) {
      colourWall = this.findWall(this.heroColor.colourName);
    } else if (this.colors && this.colors.length > 0) {
      colourWall = this.findWall(this.colors[0].colourName);
    }

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    console.log(colourWall);

    if (this.mobileView) {
      if (colourWall !== 'main' && this.wallType === 'large') {
        this.slideGrid('right');
      } else if (colourWall !== 'main' && this.wallType === 'small') {
        this.slideGrid('left');
      }
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    onZoom(panzoomInstance) {
      if (panzoomInstance.getTransform().scale <= 1) { //hide slide to whites/colourbonds option when zoomed in
        this.allowSlide = true;
      } else {
        this.allowSlide = false;
      }
    },
    handleResize() {
      window.innerWidth > 767 ? this.mobileView = false : this.mobileView = true
    },
    slideGrid(slide){
      this.slide = slide //slide left center or right
    },
    goToColorWall() {
      return;
    },
    goToColorList() {
      this.$router.push('/results-list')
    },
    findWall(colorName) {
      if (this.whitesWall.find(color => color.colourName === colorName)) {
        return 'whites';
      }

      if (this.neutralsWall.find(color => color.colourName === colorName)) {
        return 'neutrals';
      }

      if (this.greysWall.find(color => color.colourName === colorName)) {
        return 'greys';
      }

      if (this.colorbondWall.find(color => color.colourName === colorName)) {
        return 'colorbond';
      }

      return 'main';
    }
  },
}
</script>
<style lang="scss">
  h3 {
    font-size: 15px;
    margin: 10px 0 10px 0;

    &:first-child {
      margin-top: 0;
    }
  }
</style>